import { createSlice } from "@reduxjs/toolkit"

export const projectReducer = createSlice({
    name: 'projectReducer',
    initialState: {
        isLoading: false,
        isLoadingSmetas: false,
        isLoadingImage: false,
        isLoadingCost: false,
        isLoadingCompare: false,
        projectAnalog: null,
        objectSmetas: null,
        smetas: null,
        prices: null,
        resources: null,
        limitedCosts: null,
        scheme: null,
        error: null,
        oneProject: null,
        objectAnalogList: null,
        createdProject: null,
        uploadedObjectFiles: null,
        pagePriceByProjectId: null,
        savePtmDescriptionResponse: null,
        changedImages: null,
        changedJsonLines: null,
        changed: null,
        projectAnalogsList: null,
        projectAnalogDictionary: {},
        savePtmDescription: null,
        deleted: false,
        ptmList: null,
        ptmsWithDescription: null,
        compareObjects: [],
        compareObjectsForm1: null,
        compareObjectsForm2: null,
        explications: null,
        projectFiles: null,
        objectUpdated: null,
    },
    reducers: {
        setLoadingImage: (state) => {
            state.isLoadingImage = true
        },
        setLoading: (state) => {
            state.isLoading = true
            state.changed = null
        },
        setLoadingSmetas: (state) => {
            state.isLoadingSmetas = true
        },
        setLoadingCompare: (state) => {
            state.isLoadingCompare = true
        },
        setError: (state, action) => {
            state.isLoading = false
            state.isLoadingSmetas = false
            state.isLoadingCost = false
            state.isLoadingCompare = false
            state.error = action.payload
        },
        uploadObjectFilesSuccess: (state, action) => {
            state.isLoadingImage = false
            state.changedImages = action.payload ? 'Изображения успешно загружены!' : null
            state.uploadedObjectFiles = action.payload
        },
        uploadJsonLinesSuccess: (state, action) => {
            state.isLoading = false
            state.changedJsonLines = action.payload ? 'Файл успешно загружен!' : null
            state.createdProject = action.payload
        },
        getProjectAnalogSuccess: (state, action) => {
            state.isLoading = false
            state.projectAnalog = action.payload
        },
        getObjectSmetasSuccess: (state, action) => {
            state.isLoading = false
            state.objectSmetas = action.payload
        },
        getSchemas: (state, action) => {
            state.isLoading = false
            state.scheme = action.payload
        },
        getSmetasSuccess: (state, action) => {
            state.isLoadingSmetas = false
            state.smetas = action.payload
        },
        getPricesSuccess: (state, action) => {
            state.isLoading = false
            state.prices = action.payload
        },
        getResourcesSuccess: (state, action) => {
            state.isLoading = false
            state.resources = action.payload
        },
        getLimitedCostsSuccess: (state, action) => {
            state.isLoading = false
            state.limitedCosts = action.payload
        },
        getProjectsAnalogSuccess: (state, action) => {
            state.isLoading = false
            state.projectAnalogsList = action.payload
            state.projectAnalogDictionary[action.payload.page] = action.payload.items
        },
        getAnalogProjectByIdSuccess: (state, action) => {
            state.isLoading = false
            state.oneProject = action.payload
        },
        getObjectAnalogSucsess: (state, action) => {
            state.isLoading = false
            state.objectAnalogList = action.payload
        },
        deleteProjectsAnalogSuccess: (state, action) => {
            state.isLoading = false
            state.deleted = action.payload
        },
        clearDelete: (state) => {
            state.isLoading = false
            state.deleted = false
        },
        clearDictionary: (state) => {
            state.projectAnalogDictionary = {}
        },
        getPagePriceByProjectIdSuccess: (state, action) => {
            state.isLoading = false
            state.pagePriceByProjectId = action.payload
        },
        savePtmDescriptionSuccess: (state, action) => {
            state.isLoading = false
            state.changed = action.payload ? "Данные успешно изменены" : null
            state.savePtmDescriptionResponse = action.payload
        },
        createObjCharacteristicSuccess: (state, action) => {
            state.isLoading = false
            state.savePtmDescription = action.payload
        },
        getAnalogObjectsByProjectIdSuccess: (state, action) => {
            state.isLoading = false
            state.objectAnalogList = action.payload
        },
        setLoadingCost: (state) => {
            state.isLoadingCost = true
        },
        getAllPtmByObjectIdSuccess: (state, action) => {
            state.isLoadingCost = false
            const payload = [...action.payload]
            // payload.push(payload.find(p => p.code === "10"))
            // payload.splice(payload.findIndex(p => p.code === "10"), 1)
            state.ptmList = payload
        },
        getAllPtmDescriptionByObjectIdSuccess: (state, action) => {
            state.isLoadingCost = false
            state.ptmsWithDescription = action.payload
        },
        addCompareObject: (state, action) => {
            if (!state.compareObjects?.includes(action.payload)) {

                state.compareObjects.push(action.payload)
            } else {
                state.compareObjects = state.compareObjects.filter(co => !(co === action.payload))
            }
        },
        clearCompareObjectSuccess: (state) => {
            state.compareObjects = []
        },
        getSummaryCostsSuccess: (state, action) => {
            const ndsSummuryCost = action.payload?.analogObjects?.map(ao => {
                return {
                    analogObjectId: ao.analogObjectId,
                    cost: ao.nds,
                    rePTMCode: "99"
                }
            })

            const result = action.payload

            result.summaryCosts?.forEach(sc => {
                if (sc.rePTMCode === "2" || sc.rePTMCode === "3") {
                    const allCost = {
                        analogObjectId: sc.analogObjectId,
                        cost: sc.cost,
                        rePTMCode: `${sc.rePTMCode}-99`
                    }
                    result.summaryCosts?.push(allCost)
                }
            })

            result.analogObjects?.forEach(ao => {
                let sum = 0
                result.summaryCosts.filter(record => ((record.rePTMCode?.split("-").length < 2
                    || record.rePTMCode?.split("-").includes("99"))
                    && ao.analogObjectId === record.analogObjectId)).forEach(sc => {
                        sum += sc.cost
                    })
                result.summaryCosts?.push({
                    analogObjectId: ao.analogObjectId,
                    cost: sum.toFixed(2),
                    rePTMCode: `99-99`
                })
            })

            result.summaryCosts?.push(...ndsSummuryCost)
            result.ptmLevel12s?.push({
                rePTMCode: "99",
                notShowCode: true,
                rePTMName: "НДС"
            })
            result.ptmLevel12s?.splice(result.ptmLevel12s.findIndex(p => p.rePTMCode === "3"), 0, {
                rePTMCode: "2-99",
                notShowCode: true,
                rePTMName: "Всего:"
            })
            result.ptmLevel12s?.splice(result.ptmLevel12s.findLastIndex(p => p.rePTMCode.split("-")[0] === "3") + 1, 0, {
                rePTMCode: "3-99",
                notShowCode: true,
                rePTMName: "Всего:"
            })
            result.ptmLevel12s?.push({
                rePTMCode: "99-99",
                notShowCode: true,
                rePTMName: "Общая стоимость:"
            })

            state.isLoadingCompare = false
            state.compareObjectsForm1 = result
        },
        getMinMaxCostsSuccess: (state, action) => {
            state.isLoadingCompare = false
            state.compareObjectsForm2 = action.payload
        },
        getExplicationsSuccess: (state, action) => {
            state.isLoading = false
            state.explications = action.payload
        },
        getAllProjectFilesSuccess: (state, action) => {
            state.isLoading = false
            state.projectFiles = action.payload
        },
        updateAnalogObjectSuccess: (state, action) => {
            state.isLoading = false
            state.objectUpdated = action.payload
        },
        clearUpdateProject: (state) => {
            state.oneProject = null
            state.ptmsWithDescription = null
            state.objectUpdated = null
            state.projectFiles = null
            state.changedImages = null
        },
        clearProjectCreateSuccess: (state) => {
            state.savePtmDescription = null
            state.changedImages = null
            state.changedJsonLines = null
            state.createdProject = null
            state.isLoading = null
            state.objectAnalogList = null
        }
    }
})

export default projectReducer.reducer